<template>
	<div data-component="lesson-resources-by-categories">
		<template v-if="getResourcesGroupedByCategory.length">
			<div
				v-for="(category, key) in getResourcesGroupedByCategory"
				:key="key"
				data-element="lesson-resource-category"
			>
				<h2 data-element="heading">
					<span data-element="icon-circle">
						<icon :icon="category.icon" colour="transparent" />
					</span>
					{{ category.name }}
				</h2>
				<div data-element="resource-category-list">
					<div
						v-for="(resource, key) in category.resources"
						:key="key">
						<slot :resource="resource" />
					</div>
				</div>
			</div>
		</template>
		<template v-else>
			<slot name="empty-state" />
		</template>
	</div>
</template>

<script>

	import Icon from '@/components/ui/Icon';
	import { resourceCategoryOptions } from '@/consts';

	export default {
		components: {
			Icon
		},
		props: {
			media: {
				type: Array,
				default: () => ([])
			}
		},
		computed: {
			getResourcesGroupedByCategory () {
				const groupedByCategory = this.media.reduce((acc, current) => {
					acc[current?.config?.type] = [...acc[current?.config?.type] || [], current];
					return acc;
				}, {});

				return resourceCategoryOptions
					.map(category => {
						if (groupedByCategory[category.value]?.length) {
							return {
								name: category.text,
								icon: category.icon,
								resources: groupedByCategory[category.value]
							};
						}
					}).filter(Boolean);
			}
		},
		methods: {}
	};

</script>

<style lang="scss" scoped>

[data-component='lesson-resources-by-categories'] {
	margin-bottom: 36px;

	[data-element='lesson-resource-category'] {
		[data-element='heading'] {
			display: flex;
			align-items: center;
			gap: 10px;
			margin-bottom: 12px;
			@include font(18px, $c-darkest-navy, 700, 23px);

			[data-element='icon-circle'] {
				display: flex;
				justify-content: center;
				align-items: center;
				width: 26px;
				height: 26px;
				border-radius: 50%;
				background-color: #3F4A58;

				::v-deep [data-component='icon'] {
					flex-shrink: 0;
					width: 14px;
					height: auto;
					* {
						fill: $c-white;
					}
				}
			}
		}

		[data-element='resource-category-list'] {
			display: flex;
			flex-direction: column;
			gap: 4px;
		}

		&:not(:first-child) {
			margin-top: 12px;
		}
	}
}

</style>
